import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Sections from './components/Sections';
import Feed from './components/Feed';
import Community from './components/Community';
import Faq from './components/Faq';
import PostSection from './components/PostSection';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

function Home() {
  return (
    <div className="bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Sections />
        <Feed />
        <Community />
        <Faq />
        <PostSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default Home;